// Leaf module (no imports) so glazier-agent-core can reach the lead funnel by relative path. See
// docs/lead-conversion.md, "Shape of the implementation".

// Sentinel in the owner / source filters meaning "leads with none". Negative so it can never
// collide with a real row id.
export const LEAD_FILTER_NONE = -1;

export const matchesIdFilter = (selected: number[], value: number | null): boolean =>
	selected.length === 0 || selected.includes(value ?? LEAD_FILTER_NONE);

// `origin` is NOT NULL, so unlike the id filters there is no "none" bucket and no sentinel standing in
// for one — a plain membership test is the whole rule.
export const matchesEnumFilter = <T extends string>(selected: T[], value: T): boolean => selected.length === 0 || selected.includes(value);
